<div class="lp-detail text-center" (click)="routeToInsructorPage(instructorInfo)">
	<figure >
        <img alt="profile" [src]="imageUrl + instructorInfo?.image?.path + instructorInfo?.image?.name" style="cursor: pointer;">
        <span class="profile-active"><img src="assets/images/tick-icn.svg" alt="tick"></span>
	</figure>
	<div  class="info">
		<h4  style="cursor: pointer;">{{ instructorInfo?.firstName }} {{ instructorInfo?.lastName }}</h4>
		<div  class="rate-stars">
			<span class="lp-rating">
                <!-- <img src="assets/images/rates-img.svg" alt="rating"></span><span  class="rate-txt d-block">
                Rating {{ instructorInfo?.rating }} -->
                <ngb-rating [(rate)]="instructorInfo.avgRating" [max]="5" style="pointer-events: none;">
                    <ng-template let-fill="fill">
                      <span class="star bad" [class.full]="fill === 100">
                        <span class="half bad" [style.width.%]="fill">&#9733;</span>&#9733;
                      </span>
                    </ng-template>
                  <span>{{ userDashboardService.getRound(instructorInfo.rating) }}</span>
                </ngb-rating>
            </span>
        </div>
        <div class="lp-tags">
            <div class="tag-wrap">
                <span *ngFor="let i of instructorInfo?.category | slice:0:5">
                  {{i.name}}
                </span>
            </div>
        </div>
	</div>
</div>
